import { createContext, useContext } from 'react';

/**
 * Ce que la coque offre aux écrans — #75, corrigé par #85.
 *
 * ## Pourquoi ce contexte existe
 *
 * `ApplicationMobile` posait un en-tête au-dessus de CHAQUE écran porté, avec le
 * libellé du registre. Les écrans qui ont leur propre en-tête — le fil, qui porte
 * le nom du client et le retour ; les conversations fermées, qui portent leur
 * titre — se retrouvaient donc avec **deux barres empilées** : « Messagerie » puis
 * « Antoine ROUSSEL ». Soit environ 120 px de chrome sur 844, pour un seul bouton
 * utile, et deux `h1` sur la même page.
 *
 * C'était cher au mauvais endroit : #34 s'est battu pour que la barre de saisie
 * reste visible au-dessus du clavier, et une barre de trop la repousse d'autant.
 *
 * L'en-tête appartient donc désormais à **l'écran**, qui sait ce qu'il a à dire.
 * La coque ne fournit plus qu'une chose : de quoi ouvrir le panneau — la seule
 * partie qui ne lui appartient pas.
 */
interface Coque {
    ouvrirPanneau: () => void;
    /**
     * Le nombre de catalogues de l'établissement sélectionné — l'unique axe
     * d'éligibilité de l'écran « Commandes » (#40, #87).
     *
     * Il vit ICI et non dans `useEcrans` parce que celui-ci est un **assemblage
     * de ce qui est déjà dans le navigateur** : y poser une requête le rendrait
     * intestable sans fournisseur, et le rendrait faux pendant son chargement.
     *
     * `undefined` tant qu'on ne sait pas — et « on ne sait pas » vaut « pas
     * d'écran », jamais l'inverse : mieux vaut une entrée qui apparaît une
     * seconde plus tard qu'une entrée qui promet ce qui n'existe pas (#17 §7).
     */
    nombreDeCatalogues?: number;
}

const CoqueContext = createContext<Coque>({ ouvrirPanneau: () => {} });

export const CoqueProvider = CoqueContext.Provider;

export function useCoque(): Coque {
    return useContext(CoqueContext);
}
